import { Component, OnInit, Inject, Injector, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamReportsClient } from '../../../../generated-client/generated-api-client';
import {
  DatatableActionButton,
  DatatableEvent,
  DatatableHandler,
  DatatableHandlerEvents,
  DatatableHandlerSettings,
  IconType,
} from '../../../../components/datatables/datatable/datatable/datatable.component';
import { SimpleNavigationPathDataService } from '../../../../services/data-services/navigation-data-services';
import { SimpleModalService } from 'ngx-simple-modal';
import { ConfirmModalComponent } from '../../../../components/modals/confirm-modal/confirm-modal.component';
import { AddExaminerModalComponent } from '../../../../components/modals/add-examiner-modal/add-examiner-modal.component';
import { ToastrService } from 'ngx-toastr';
import { SyncDataService } from '../../../../services/data-services/sync-data.service';
import { ExamReportDataService } from 'src/app/services/data-services/exam-report-data.service';
import { DataTableRoutes } from 'src/app/constants/datatableUrls';
import { ErrorProcessorService } from '../../../../services/error-processor.service';

@Component({
  selector: 'app-exam-report-examiners-tab',
  templateUrl: './exam-report-examiners-tab.component.html',
  styleUrls: ['./exam-report-examiners-tab.component.sass'],
})
export class ExamReportExaminersTabComponent implements OnInit {
  id: string = '';
  dtHandler?: DatatableHandler;
  dtSettings: DatatableHandlerSettings = DatatableHandler.getDefaultSettings();
  dtDataSourceUrl!: string;
  dtEvents: DatatableHandlerEvents = DatatableHandler.getDefaultEvents();

  constructor(
    @Inject(Injector) private injector: Injector,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private examinerNavigationService: SimpleNavigationPathDataService,
    private _modalService: SimpleModalService,
    private _examReportClient: ExamReportsClient,
    private _syncService: SyncDataService,
    private errorProcessorService: ErrorProcessorService
  ) {
    route.parent?.paramMap.subscribe(next => {
      this.id = next.get('id') ?? '';
    });
    this.dtDataSourceUrl = `${DataTableRoutes.ExaminerList}?ExamReportId=${this.id}`;

    this.navigateBackData = this.router.url;
    this.navigateToData = this.router.url;

    this.dtSettings.actions = this._dtActionButtonsFn;
  }

  private get toastrService(): ToastrService {
    return this.injector.get(ToastrService);
  }

  set navigateBackData(value: string) {
    this.examinerNavigationService.navigateBackPath = value;
  }

  set navigateToData(value: string) {
    this.examinerNavigationService.navigateToPath = value;
  }

  ngOnInit(): void {
    this._examReportClient.get(this.id).subscribe(examReport => {
      this.titleService.setTitle(examReport.identifier + ' - vizsgabiztosai');
    });
  }

  onDtInit(dtHandler: DatatableHandler): void {
    this.dtHandler = dtHandler;
    this._examReportClient.status(this.id).subscribe(next => {
      if (next === undefined) {
        return;
      }

      this.setArchivedSpecificDtSettings(next == "Closed");
      this.dtHandler?.create();
    });
  }

  onDtAction(event: DatatableEvent) {
    if (event.actionId === 'remove') {
      this.remove(event.data['id']);
    }
  }

  private remove(studentId: string): void {
    this._modalService
      .addModal(ConfirmModalComponent, {
        title: 'Vizsgabiztos eltávolítása',
        message: 'Biztosan eltávolítja a jegyzőkönyvről a vizsgabiztost?',
        confirmText: 'Igen',
        confirmClass: 'btn-danger text-white',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this._examReportClient.unAssignExaminer(this.id, studentId).subscribe(
            () => {
              this.toastrService.success('Sikeres eltávolítás');
              this.dtHandler?.refresh();
              this._syncService.afterSuccessfulOperation.next();
            },
            error => {
              this.errorProcessorService.processError(error, true);
              this.dtHandler?.refresh();
            }
          );
        }
      });
  }

  private _dtActionButtonsFn: (data: any) => DatatableActionButton[] = data => {
    const removeAction = new DatatableActionButton(
      'remove',
      'Vizsgabiztos eltávolítása jegyzőkönyvről',
      'close',
      undefined,
      IconType.Danger
    );

    return [removeAction];
  };

  private setArchivedSpecificDtSettings(isArchived: boolean): void {
    if (!isArchived) {
      this.dtSettings.buttons = [
        {
          text: 'Új vizsgabiztos',
          class: 'btn-primary text-white',
          action: () => {
            this._modalService
              .addModal(AddExaminerModalComponent, {
                examReportId: this.id,
              })
              .subscribe(isConfirmed => {
                if (isConfirmed) {
                  this.toastrService.success('Sikeres vizsgabiztos hozzárendelés');
                  this.dtHandler?.refresh();
                  this._syncService.afterSuccessfulOperation.next();
                }
              });
          },
        },
      ];
    } else {
      this.dtSettings.additionalColumns = [
        {
          targets: 4,
          orderable: false,
          visible: false,
        },
      ];
    }
  }
}
